'use client';
import { DownloadIcon } from '@chakra-ui/icons';
import {
  Box,
  Container,
  Flex,
  Heading,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Table,
  Tbody,
  Td,
  Text,
  Tr,
} from '@chakra-ui/react';
import { Button } from '@chakra-ui/react';
import React from 'react';

import LinkCustom from '@/app/_components/link/LinkCustom';
import { ReactComponent as Check } from '@/app/_icons/check-white.svg';
import { getDownloadLink } from '@/services/link.service';

import Styles from './SafetyReport.module.scss';

const dataSource = [
  {
    id: '1',
    specPassedMark: true,
    specName: 'Chassis components',
    specPassed: true,
  },
  {
    id: '2',
    specPassedMark: true,
    specName: 'Seat belts and restraints',
    specPassed: true,
  },
  {
    id: '3',
    specPassedMark: true,
    specName: 'Battery health',
    specPassed: true,
  },
  {
    id: '4',
    specPassedMark: true,
    specName: 'Exhaust component',
    specPassed: true,
  },
  {
    id: '5',
    specPassedMark: true,
    specName: 'Steering components',
    specPassed: true,
  },
  {
    id: '6',
    specPassedMark: true,
    specName: 'Air filters',
    specPassed: true,
  },
  {
    id: '7',
    specPassedMark: true,
    specName: 'Belts and hoses',
    specPassed: true,
  },
  {
    id: '8',
    specPassedMark: true,
    specName: 'Shocks and struts',
    specPassed: true,
  },
];

const SafetyReport = ({
  dekraReport,
}: {
  dekraReport: { pdf_report: string };
}) => {
  return (
    <Container
      maxW={'1280'}
      width={'100%'}
      className={Styles.safetyReportWrapper}
      paddingY={{ base: 10, lg: 20 }}
      paddingX={{ base: 10, lg: 4 }}
    >
      <Flex
        justifyContent={'space-between'}
        alignItems={{ base: 'flex-start', lg: 'flex-end' }}
        direction={{ base: 'column', lg: 'row' }}
        gap={4}
        marginBottom={10}
      >
        <Box className={Styles.headingElement} maxWidth={'750px'}>
          <Text fontSize={'xs'} marginBottom={4}>
            Dekra Report
          </Text>
          <Heading as="h2" className={Styles.titleLg} marginBottom={4}>
            Safety & Inspection
          </Heading>

          <Text marginBottom={4}>
            All our vehicles undergo a Dekra Condition Report and an EXSTRA
            quality check at our workshop for that peace of mind motoring.
          </Text>
          <Box>
            <Popover>
              <PopoverTrigger>
                <Button
                  className={Styles.btnTextLink}
                  padding={0}
                  height={'auto'}
                >
                  <Text className={Styles.linkText}>
                    What is a Dekra Report
                  </Text>
                </Button>
              </PopoverTrigger>

              <PopoverContent borderRadius={0}>
                <PopoverArrow />
                <PopoverCloseButton />
                <PopoverBody>
                  A DEKRA Condition Report is a customised, professional used
                  vehicle condition evaluation completed by expert DEKRA
                  Examiners. This report can be used when you are in the process
                  of purchasing a vehicle, you will have a higher level of
                  buying and selling confidence knowing that a vehicle has been
                  independently inspected by an expert. The quality of the DEKRA
                  Condition Report will provide you with complete peace of mind
                  if you are selling or purchasing a vehicle
                </PopoverBody>
              </PopoverContent>
            </Popover>
          </Box>
        </Box>
        <Box>
          <LinkCustom
            className="btnOutline"
            href={getDownloadLink(dekraReport?.pdf_report)}
            download
            target="_blank"
            rel="noopener noreferrer"
          >
            Download Report <DownloadIcon />
          </LinkCustom>
        </Box>
      </Flex>
      <Box>
        <Box className={Styles.headingElement}>
          <Heading as="h4" className={Styles.titleMd} marginBottom={4}>
            Dekra Report
          </Heading>
        </Box>
        <Table className={Styles.safetyReportTable}>
          <Tbody>
            {dataSource.map((content, index) => (
              <Tr key={index}>
                <Td className={Styles.specPassedMark}>
                  <Box className={Styles.specPassedMarkSymbole}>
                    <Check />
                  </Box>
                </Td>
                <Td className={Styles.specName}>{content.specName}</Td>
                <Td className={Styles.specPassed}> Passed</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </Container>
  );
};

export default SafetyReport;
